module.exports = __webpack_public_path__ + "img/td.e6f55d83.svg";